import { transformDateToLocalDateString } from "helpers";
import { ContactNoteRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";




export const CONTACT_NOTE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {
  return [
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactNoteRow) => {
        return (
          
            <TableIcon
              imageUrl={row.userCreated?.avatar}
              initials={`${row.userCreated?.firstName?.charAt(0)?.toUpperCase() ?? ""}${row.userCreated?.lastName?.charAt(0)?.toUpperCase() ?? ""}`}
            />
     
        );
      },
    },

    {
      title: t("admin.contact.note.table.content"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactNoteRow) => {
        return (
          <div className="w-full max-w-lg">
            <p className="text-sm text-slate-700 truncate" title={row.content}>
              {row.content}
            </p>
          </div>
        );
      },
    },
     {
      title: t("admin.contact.note.table.created"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactNoteRow) => {
        return (
          <div className="w-full max-w-lg">
             {transformDateToLocalDateString(row.created)}
          </div>
        );
      },
    },
    {
      title: t("admin.contact.note.table.important"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactNoteRow) => {
        return (
          <Badge
            text={row.important ? "DA" : "NE"}
            variant={row.important ? "success" : "danger"}
          />
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactNoteRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
              {t("admin.delete")}
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];
};
